import { render, staticRenderFns } from "./TaxFilingItem.vue?vue&type=template&id=76a49b41&scoped=true&"
import script from "./TaxFilingItem.vue?vue&type=script&lang=js&"
export * from "./TaxFilingItem.vue?vue&type=script&lang=js&"
import style0 from "./TaxFilingItem.vue?vue&type=style&index=0&id=76a49b41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a49b41",
  null
  
)

export default component.exports